<template>
	<div class="floating-sidebar">
		
		<div class="sidebar-item" @click="openCart">
			<el-badge :value="cartCount"  class="cart-badge">
				<el-icon :size="24"><ShoppingCart /></el-icon>
			</el-badge>
			<span>购物车</span>
		</div>
		<el-popover
			content="4008003135"
			placement="left"
			title="客服热线"
			trigger="hover"
		>
			<template #reference>
				<div class="sidebar-item" @click="openChat">
					<el-icon :size="24"><Service /></el-icon>
					<span>客服</span>
				</div>
			</template>
		</el-popover>
		<el-popover
			content="4008003135"
			placement="left"
			title="投诉热线"
			trigger="hover"
		>
			<template #reference>
				<div class="sidebar-item" @click="openComplaint">
					<el-icon :size="24"><Warning /></el-icon>
					<span>投诉</span>
				</div>
			</template>
		</el-popover>
	</div>
</template>

<script>
import { Service, ShoppingCart, Warning } from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'

export default {
	name: 'FloatingSidebar',
	components: {
		Service,
		ShoppingCart: ShoppingCart,
		Warning
	},
	data() {
		return {
			cartCount: 0
		}
	},
	mounted() {
		this.getCartCount()
	},
	methods: {
		openChat() {
			//ElMessage.info('正在连接客服...')
		},
		openCart() {
			const { href } = this.$router.resolve({
					path: '/user',
					query: {type: 'shopping' }
				});
				window.open(href, '_blank');
		},
		openComplaint() {
			//ElMessage.info('投诉功能开发中')
		},
		getCartCount() {
			this.$axios.post('/api/yunsys.Cart/countcart')
				.then(res => {
					var res = res.data;
					if (res.code === 0) {
						this.cartCount = res.data.cart_num || 0;
					}
				})
				.catch(err => {
					console.log(err);
				});
		},
		updateCartCount(count) {
			this.getCartCount();
		}
	}
}
</script>

<style lang="less" scoped>
.floating-sidebar {
	position: fixed;
	right: 0;
	top: 50%;
	transform: translateY(-50%);
	z-index: 1000;
	background: rgba(255, 255, 255, 0.95);
	backdrop-filter: blur(10px);
	border-radius: 8px 0 0 8px;
	box-shadow: -2px 0 8px rgba(0, 0, 0, 0.1);
	padding: 20px 15px;
	display: flex;
	flex-direction: column;
	gap: 25px;
	border: 1px solid rgba(0, 0, 0, 0.08);
}

.sidebar-item {
	display: flex;
	flex-direction: column;
	align-items: center;
	cursor: pointer;
	color: #606266;
	transition: all 0.3s ease;
	border-radius: 6px;

	&:hover {
		color: #ff8a5c;
		background: rgba(255, 138, 92, 0.1);
		transform: translateX(-5px);
	}

	.el-icon {
		margin-bottom: 5px;
	}

	span {
		font-size: 12px;
		white-space: nowrap;
	}
}

.cart-badge {
	:deep(.el-badge__content) {
		background-color: #ff8a5c;
		border-color: #ff8a5c;
	}
}
</style>